import React from 'react';
import MainContent from '../../components/mainContent/MainContent';
import { HonorariosFidelizadosContent } from './components/HonorariosFidelizadosContent';

export default function AdminHonorarioFidelizado() {
  return (
    <MainContent
      component={<HonorariosFidelizadosContent />}
      titulo='Administración de honorarios fidelizados'
      noBackground
      tableMaxWidth
    />
  );
}
